import React from 'react'
import styles from './Badge.module.scss'

/**
 * Универсальный бейдж со статусами.
 *   <Badge variant="success">Активно</Badge>
 *   <Badge variant="warning" dot>Ожидание</Badge>
 *   <Badge variant="danger" outlined>Отклонено</Badge>
 */
const VARIANTS = ['default', 'accent', 'success', 'warning', 'danger', 'info', 'muted']

const Badge = ({
  children,
  variant = 'default',
  dot = false,
  outlined = false,
  size = 'md',
  className = '',
}) => {
  const v = VARIANTS.includes(variant) ? variant : 'default'
  return (
    <span
      className={[
        styles.badge,
        styles[v],
        outlined ? styles.outlined : '',
        styles[size] || '',
        className,
      ].filter(Boolean).join(' ')}
    >
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  )
}

export default Badge
